import React, { Component } from 'react';
import styles from './InputGroup.module.scss';
import classNames from 'classnames/bind';

import {InputGuide, LabelText} from '../../atoms';
import {Input} from '../../molecules';

const cx = classNames.bind(styles);

class InputGroup extends Component {

  render() {
    const { inputType, inputName, inputPlaceholder, labelText, isError, value, onChange, onBlur, inputGuideText, defaultHideGuide, className } = this.props;
    return (
      <div className={`${cx('InputGroup')} ${className}`}>
        <LabelText className={cx('InputGroup__label')} text={labelText} />
        <Input
          className={cx('InputGroup__input')}
          type={inputType}
          name={inputName}
          placeholder={inputPlaceholder}
          isError={isError}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        <InputGuide className={cx('InputGroup__input-guide')} text={inputGuideText} isError={isError} defaultHide={defaultHideGuide} />
      </div>
    );
  }
}

export default InputGroup;
